<template>
  <div class="login">
    <div class="banner">
      <img src="../assets/images/login_banner.png" alt="" />
    </div>

    <div class="form_data">
      <div class="tit">用户登录</div>
      <!-- <div class="tit">选择您的登录身份</div> -->
      <van-radio-group
        v-model="radio"
        direction="horizontal"
        class="radio_group flex-around"
        v-if="false"
      >
        <van-radio name="管理员" checked-color="#ee0a24">管理员</van-radio>
        <van-radio name="商户用户" checked-color="#ee0a24">商户用户</van-radio>
        <!-- <van-radio name="企业员工" checked-color="#ee0a24">企业员工</van-radio> -->
      </van-radio-group>
      <div class="input_box">
        <van-field v-model="name" placeholder="请输入手机号码" />
      </div>
      <div class="input_box">
        <van-field :type="pwdType" v-model="pwd" placeholder="密码" />
        <div class="visual" @click="handleVisualPwd">
          <i
            class="iconfont"
            :class="
              pwdType == 'password' ? 'icon-icon_xianshi' : 'icon-xianshi'
            "
          ></i>
        </div>
      </div>
      <!-- <div class="verify-wrap">
        <Verify
          :type="3"
          :barSize="barSize"
          :showButton="false"
          @success="successVerify"
        ></Verify>
      </div> -->
      <div class="custom_btn" @click="login">登录</div>
      <div class="register">
        <p @click="handleRegister">注册新用户→</p>
      </div>
    </div>

    <!-- 验证码 -->
    <van-overlay :show="isShow" @click="isShow = false"> </van-overlay>
    <div class="popup_box" v-if="isShow" @click.self="isShow = false">
      <div class="popup_wrapper">
        <div class="popup_header flex-between">
          <div class="tit">请完成安全验证</div>
          <van-icon name="cross" @click="isShow = false" />
        </div>
        <div class="popup_content flex-rowc">
          <div class="verify-wrap">
            <Verify
              :type="3"
              :barSize="barSize"
              :showButton="false"
              @success="successVerify"
              @error="erroeVerify"
            ></Verify>
          </div>
        </div>
      </div>
    </div>

    <van-popup :round="true" v-model="isShowReg" @click="onClose">
      <div class="register_popup">
        <div class="img">
          <img src="../assets/images/register_ercode_new.png" alt="" />
        </div>
        <div class="txt">请长按扫码<br />进入小程序后授权注册</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Verify from "vue2-verify";
import { userLogin, getToken, getUserInfo } from "../api/api";
export default {
  name: "login",
  components: { Verify },
  data() {
    return {
      isShow: false,
      barSize: {
        width: "100%",
        height: "40px",
      },
      isVerify: false, // 是否验证成功

      isShowLoad: true, // 默认为加载中

      isShowReg: false, // 是否显示注册弹窗
      pwdType: "password",
      radio: "商户用户",
      name: "",
      pwd: "",
    };
  },
  created() {},
  methods: {
    // 密码显示
    handleVisualPwd() {
      this.pwdType = this.pwdType == "password" ? "text" : "password";
    },
    handleRegister() {
      this.$router.push("/register");
      // this.isShowReg = true;
    },
    onClose() {
      this.isShowReg = false;
    },
    successVerify() {
      this.isVerify = true;
      this.userSubmit();
    },
    // 拖动滑块失败
    erroeVerify(obj) {
      this.verify = false;
      this.code = "";
      obj.refresh();
    },
    login() {
      let { radio, name, pwd } = this;
      if (radio == "") {
        this.$toast("请选择登录身份");
        return;
      }
      if (name == "") {
        this.$toast("请输入手机号码");
        return;
      }
      if (pwd == "") {
        this.$toast("请输入密码");
        return;
      }
      // if (!isVerify) {
      //   this.$toast("请拖动滑块验证");
      //   return;
      // }
      this.isShow = true;
      // let params = {
      //   usertype: 1, // 1 个人用户 2 企业用户
      //   loginname: name,
      //   loginpwd: pwd,
      // };
      // this.userSubmit(params);
    },

    userSubmit() {
      let { name, pwd } = this;
      let params = {
        usertype: 1, // 1 个人用户 2 企业用户
        loginname: name,
        loginpwd: pwd,
      };
      this.isShow = false;
      const toast = this.$toast.loading({
        message: "登录中...",
        forbidClick: true,
      });
      userLogin(params).then((res) => {
        toast.clear();
        if (res.result) {
          this.$toast.success(res.message);
          this.$store.commit("updateOpenid", res.code);
          this.getToken();
          this.getUserInfo(res.code);
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 获取token
    getToken() {
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    getUserInfo(openid) {
      getUserInfo({ openid }).then((res) => {
        if (Object.keys(res).length > 0) {
          this.$store.commit("updateUserInfo", res);
          // this.$store.dispatch("updateUserInfo", res);
          setTimeout(() => {
            this.$router.push("/home");
          }, 1500);
        } else {
          this.$store.commit("updateOpenid", "");
          this.$store.commit("updateUserInfo", '');
          // this.$store.dispatch("updateUserInfo", "");
          this.$store.commit("changeLogin", "");
        }
      });
    },
  },
};
</script>
<style lang='less' scoped>
.form_data {
  padding: 88px 70px 0;
  font-size: 30px;
  .tit {
    text-align: center;
    color: #444444;
    margin-bottom: 75px;
  }
  .radio_group {
    margin: 68px auto 110px;
  }
  .input_box {
    margin-bottom: 60px;
    input {
      text-align: center;
    }
    .visual {
      position: absolute;
      top: 50%;
      right: 30px;
      transform: translateY(-50%);
      .iconfont {
        font-size: 38px;
        color: #818181;
      }
    }
  }
  .verify-wrap {
    width: 500px;
    margin: 0 auto 90px;
    font-size: 20px;
  }
  .register {
    text-align: center;
    margin-top: 73px;
    font-size: 26px;
    p {
      width: 200px;
      color: #464646;
      font-size: 24px;
      margin: 0 auto 55px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.register_popup {
  width: 500px;
  padding: 30px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 10px;
  .img {
    width: 440px;
    height: 440px;
  }
  .txt {
    margin-top: 40px;
    font-size: 28px;
    text-align: center;
  }
}
.van-popup {
  z-index: 100001 !important;
}
.verify-wrap {
  width: 500px;
  font-size: 20px;
}
.popup_box {
  height: 100vh;
  top: 0;
  position: fixed;
  z-index: 999999999999;
  width: 100%;
  .popup_wrapper {
    width: 550px;
    box-sizing: border-box;
    background: #fff;
    top: 34%;
    margin: auto;
    position: relative;
    z-index: 9999999999;
    .popup_header {
      height: 110px;
      padding: 0 20px;
      font-size: 32px;
      box-sizing: border-box;
    }
    .popup_content {
      padding: 25px 0 70px;
      position: relative;
    }
  }
}
</style>